import React from 'react'
import { motion } from 'framer-motion'

interface Props {
    children: React.ReactNode
    delay?: number
    className?: string
    style?: React.CSSProperties
}

function Reveal({ children, delay = 0, className, style }: Props) {
    return (
        <motion.div
            className={className}
            style={style}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    )
}

export default Reveal
